import { useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import MainLayout from '../components/MainLayout'

export default function AdminPage() {
  const { user } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!user?.is_superuser) navigate('/home', { replace: true })
  }, [user, navigate])

  if (!user?.is_superuser) return null

  return (
    <MainLayout>
      <div className="max-w-xl">
        <h1 className="text-2xl font-bold text-gray-900 mb-2" data-testid="admin-heading">Admin Panel</h1>
        <p className="text-gray-500 mb-8">Superuser tools for managing users and system logs.</p>

        <div className="space-y-4">
          <Link
            to="/admin/users"
            data-testid="admin-users-link"
            className="flex items-center gap-4 p-5 bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md hover:border-primary transition-all group"
          >
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-blue-200 transition-colors">
              <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
              </svg>
            </div>
            <div>
              <p className="font-semibold text-gray-900">User Management</p>
              <p className="text-sm text-gray-500">View all users, notes stats, and run migrate / backup actions.</p>
            </div>
          </Link>

          <Link
            to="/admin/logs"
            data-testid="admin-logs-link"
            className="flex items-center gap-4 p-5 bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md hover:border-primary transition-all group"
          >
            <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-purple-200 transition-colors">
              <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <div>
              <p className="font-semibold text-gray-900">Log Viewer</p>
              <p className="text-sm text-gray-500">Browse and download server log files.</p>
            </div>
          </Link>
        </div>
      </div>
    </MainLayout>
  )
}

